/**
 * Dashboard summary hook — fetches /api/dashboard/{wedding_id}.
 */
import { useCallback, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useDashboard() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchDashboard = useCallback(async (weddingId) => {
    if (!weddingId) return null;
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/dashboard/${weddingId}`, { withCredentials: true });
      setDashboard(data);
      return data;
    } catch (err) {
      console.error('Error fetching dashboard:', err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { dashboard, loading, fetchDashboard };
}
